<template>
  <v-dialog v-model="dialog" persistent max-width="800">
    <template v-slot:activator="{ on }">
      <v-btn color="primary" :disabled="!valid" v-on="on">{{ $t('addShooting.createShooting') }}</v-btn>
    </template>
    <v-card :loading="loadingSendShooting" :disabled="loadingSendShooting" class="pa-5">
      <v-card-title class="text--secondary no-word-break">
        {{ $t('addShooting.validationShooting.title') }}
      </v-card-title>
      <v-divider class="mt-2 mb-5"></v-divider>
      <v-card-text>
        <p class="text--secondary">
          {{ $t('addShooting.validationShooting.registrationNumber') }} :
          <span class="text--primary">{{ newShooting.registration }}</span>
        </p>
        <p class="text--secondary">
          {{ $t('addShooting.validationShooting.format') }} :
          <span class="text--primary">{{ newShooting.format }}</span>
        </p>
        <p class="text--secondary">
          {{ $t('addShooting.validationShooting.stock') }} :
          <span class="text--primary">{{ ownerIdOrLabel(newShooting.owner) }}</span>
        </p>
        <p class="text--secondary">
          {{ $t('addShooting.validationShooting.stampLabel') }} :
          <span class="text--primary">{{ newShooting.stamp && newShooting.stamp.name }}</span>
        </p>
        <p class="text--secondary mb-0">
          {{ $t('addShooting.validationShooting.numberOfPhotos') }} :
          <span class="text--primary">{{ newShooting.shooting.length }} ({{ formatBytes }})</span>
        </p>
        <span class="hint">{{ $t('addShooting.hintImageSize') }}</span>
      </v-card-text>
      <p v-if="checkImageSize" class="red--text text-right">{{ $t('addShooting.hintErrorImageSize') }}</p>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="secondary" outlined @click="dialog = false">{{
          $t('addShooting.validationShooting.cancel')
        }}</v-btn>
        <v-btn color="primary" :disabled="checkImageSize" @click="sendShooting">{{
          $t('addShooting.validationShooting.create')
        }}</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapGetters, mapState } from 'vuex'
import { v4 as uuidv4 } from 'uuid'

export default {
  name: 'ModalSendShooting',
  props: {
    active: Boolean,
    valid: Boolean
  },
  data() {
    return {
      dialog: false,
      loadingSendShooting: false,
      error: false
    }
  },
  computed: {
    ...mapGetters(['userId']),
    ...mapState({
      newShooting: state => state.newShooting,
      labelsOwner: state => state.labelsOwner,
      products: state => state.products
    }),
    formatBytes() {
      const decimals = 2
      let bytes = this.imagesWeight()

      if (bytes === 0) return '0 Bytes'

      const k = 1024
      const dm = decimals < 0 ? 0 : decimals
      const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB']

      const i = Math.floor(Math.log(bytes) / Math.log(k))

      return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + ' ' + sizes[i]
    },
    checkImageSize() {
      return !this.newShooting.shooting.every(e => {
        if (e.size < 5000000) {
          return true
        } else return false
      })
    }
  },
  methods: {
    ownerIdOrLabel(ownerSelected) {
      let labelToDisplay = this.labelsOwner.find(ownerList => ownerList.ownerId === ownerSelected)
      if (!labelToDisplay) return ownerSelected

      labelToDisplay.label !== '' ? (labelToDisplay = labelToDisplay.label) : (labelToDisplay = labelToDisplay.ownerId)

      return labelToDisplay
    },

    generateUUID() {
      return uuidv4()
        .toUpperCase()
        .split('-')
        .join('')
    },

    imagesWeight() {
      let size = 0

      this.newShooting.shooting.filter(el => {
        return (size += el.size)
      })

      return size
    },

    async getProductId(status) {
      let productId
      let registration = this.newShooting.registration
      let ownerId = this.newShooting.owner

      if (status === 'create') {
        productId = await this.$store.dispatch('createVirtualProduct', {
          ownerId: ownerId,
          registration: registration,
          uuid: this.generateUUID()
        })
      } else {
        productId = this.products.find(el => el && el.registration === registration).productId
      }

      return productId
    },
    async createPresignedUrl(shooting, productId) {
      let picturesList = []

      for (let i = 0; i < shooting.length; i++) {
        picturesList.push(this.generateUUID())
      }

      const presignedUrl = await this.$store.dispatch('generatePresignedUrl', {
        productId: productId,
        picturesList: picturesList
      })

      return presignedUrl
    },
    async uploadImagesOnS3(shooting, productId) {
      let x = 0
      let urlsInS3 = []

      const presignedUrl = await this.createPresignedUrl(shooting, productId)

      if (!presignedUrl || presignedUrl.length === 0) {
        return false
      } else {
        return new Promise(resolve => {
          presignedUrl.forEach(async (img, i) => {
            const photoKey = img.presignedUrl

            const res = await this.$store.dispatch('putImageOnS3', {
              presignedUrl: photoKey,
              file: shooting[i],
              url: img.url,
              order: i
            })

            if (res) {
              urlsInS3.push({ order: res.order, url: res.url })
              x++
            } else {
              resolve(false)
            }
            x === shooting.length && resolve(urlsInS3)
          })
        })
      }
    },
    createImagesBody(imagesUploadOnS3) {
      let newImage
      let data = {
        images: [],
        userId: this.userId.toString(),
        shootingType: 'standard'
      }

      if (!imagesUploadOnS3 || imagesUploadOnS3.length === 0) return

      imagesUploadOnS3.forEach((imageUrl, index) => {
        this.newShooting.stamp
          ? (newImage = {
              url: imageUrl,
              order: index,
              imageType: 'ORIGINAL',
              stampId: this.newShooting.stamp.id,
              format: this.newShooting.format
            })
          : (newImage = {
              url: imageUrl,
              order: index,
              imageType: 'ORIGINAL',
              format: this.newShooting.format
            })

        data.images.push(newImage)
      })

      return data
    },
    resetForm() {
      this.dialog = false
      this.loadingSendShooting = false
      this.$store.commit('RESET_ADD_SHOOTING_FORM')
    },
    async sendShooting() {
      let shooting = this.newShooting.shooting
      let ownerId = this.newShooting.owner
      let productId, imagesUploadOnS3, validWorkflow, data, imagesSet

      this.loadingSendShooting = true

      productId = await this.getProductId(this.newShooting.status)
      if (!productId) {
        this.loadingSendShooting = false
        return
      }

      imagesUploadOnS3 = await this.uploadImagesOnS3(shooting, productId)
      if (!imagesUploadOnS3) {
        this.loadingSendShooting = false
        return
      }

      let reorderImagesUploadOnS3 = []
      imagesUploadOnS3.forEach((el, i) => {
        const nextImage = imagesUploadOnS3.find(el => el.order === i)
        reorderImagesUploadOnS3.push(nextImage.url)
      })

      data = this.createImagesBody(reorderImagesUploadOnS3)
      if (!data || data.length === 0) {
        this.loadingSendShooting = false
        return
      }

      imagesSet = await this.$store.dispatch('setImagesfromBucket', {
        ownerId: ownerId,
        productId: productId,
        data: data
      })

      if (!imagesSet) {
        this.loadingSendShooting = false
        return
      }

      validWorkflow = await this.$store.dispatch('validWorkflow', {
        ownerId: ownerId,
        productId: productId
      })

      if (validWorkflow) {
        this.$mam.shootingsAdd()
        this.resetForm()
        this.$router.push('/shootings')
      } else {
        this.loadingSendShooting = false
        return
      }
    }
  }
}
</script>

<style lang="sass" scoped>
.no-word-break
  word-break: break-word

.hint
  font-size: 11px
</style>
